// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-picker {\n  width: 100%;\n  border-color: #bdbdbd; }\n", ""]);
// Exports
module.exports = exports;
